import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';

// Components
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';

import TimesheetImportTimesheetEntryForm from '../TimesheetImportTimesheetEntryForm';

interface Props {
    onSubmit: (timesheetEntries: any) => void;
}

const TimesheetImportTimesheetEntryModal = (
    props: Props
): React.ReactElement => {
    const { onSubmit } = props;

    const dispatch = useDispatch();
    const importTimesheetEntryModal: boolean | undefined = useSelector(
        makeSelectQueryStringValue('importTimesheetEntryModal')
    );
    const defaultValues = useSelector(
        makeSelectQueryStringValue('defaultValues')
    ) as { timesheetId?: number };

    const handleClose = (): void => {
        dispatch(
            updateQueryString({
                importTimesheetEntryModal: undefined,
                defaultValues: undefined
            })
        );
    };

    return (
        <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
            <Modal
                open={!!importTimesheetEntryModal}
                onClose={handleClose}
                size="tiny"
                centered={false}
                closeIcon
            >
                <ErrorBoundary
                    namespace="ImportTimesheetEntryModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <TimesheetImportTimesheetEntryForm
                        title="Import CSV Entries"
                        onClose={handleClose}
                        defaultValues={defaultValues}
                        onSubmit={onSubmit}
                    />
                </ErrorBoundary>
            </Modal>
        </RoleGate>
    );
};

export default TimesheetImportTimesheetEntryModal;
